import React, {useRef,useEffect, useState, useCallback  } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem  from "@mui/material/MenuItem";
import IconButton from '@mui/material/IconButton'; 
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import FormSearchStores from "pages/forms/editOrNewFormDI/FormSearchStores";
import FormSearchStoresNimaAddresses from "pages/forms/editOrNewFormDI/FormSearchStoresNimaAddress";
import FormSearchStoresAddresses from "./FormSearchStoresAddress";
import FormSearchStoreVehicles from "./FormSearchVehicles";
import PropTypes from 'prop-types';

const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0,
    "province_name":""
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const FormCreateOrEditOriTras = ({formForm,setFormForm,setIsLoadingErrorData,errorsForm,setErrorsForm,validateFormForm,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect,hasbeenshared}) => {
    const {t,i18n} = useTranslation(['listDataForms']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 

    const ori_tras_view_name = useSelector((state) => state.formatDIUser.ori_tras_view_name); 
    const ori_tras_view_contactname = useSelector((state) => state.formatDIUser.ori_tras_view_contactname); 
    const ori_tras_view_address = useSelector((state) => state.formatDIUser.ori_tras_view_address); 
    const ori_tras_view_phone = useSelector((state) => state.formatDIUser.ori_tras_view_phone); 
    const ori_tras_view_email = useSelector((state) => state.formatDIUser.ori_tras_view_email); 
    const ori_tras_view_nima = useSelector((state) => state.formatDIUser.ori_tras_view_nima); 
    const ori_tras_view_cnae = useSelector((state) => state.formatDIUser.ori_tras_view_cnae); 
    const ori_tras_view_inscription = useSelector((state) => state.formatDIUser.ori_tras_view_inscription); 
    const ori_tras_view_opt = useSelector((state) => state.formatDIUser.ori_tras_view_opt); 
    const ori_tras_view_licenseplate = useSelector((state) => state.formatDIUser.ori_tras_view_licenseplate); 
    const ori_tras_view_economicactivity = useSelector((state) => state.formatDIUser.ori_tras_view_economicactivity); 

    const ori_tras_handle_documnettype= useSelector((state) => state.formatDIUser.ori_tras_handle_documnettype); 
    const ori_tras_handle_documentid= useSelector((state) => state.formatDIUser.ori_tras_handle_documentid); 
    const ori_tras_handle_tradename= useSelector((state) => state.formatDIUser.ori_tras_handle_tradename); 
    const ori_tras_handle_name= useSelector((state) => state.formatDIUser.ori_tras_handle_name); 
    const ori_tras_handle_contactname= useSelector((state) => state.formatDIUser.ori_tras_handle_contactname); 
    const ori_tras_handle_address= useSelector((state) => state.formatDIUser.ori_tras_handle_address); 
    const ori_tras_handle_phone= useSelector((state) => state.formatDIUser.ori_tras_handle_phone); 
    const ori_tras_handle_email= useSelector((state) => state.formatDIUser.ori_tras_handle_email); 
    const ori_tras_handle_nima= useSelector((state) => state.formatDIUser.ori_tras_handle_nima); 
    const ori_tras_handle_cnae= useSelector((state) => state.formatDIUser.ori_tras_handle_cnae); 
    const ori_tras_handle_inscription= useSelector((state) => state.formatDIUser.ori_tras_handle_inscription); 
    const ori_tras_handle_opt= useSelector((state) => state.formatDIUser.ori_tras_handle_opt); 
    const ori_tras_handle_licenseplate= useSelector((state) => state.formatDIUser.ori_tras_handle_licenseplate); 
    const ori_tras_handle_economicactivity= useSelector((state) => state.formatDIUser.ori_tras_handle_economicactivity); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);     
    const [showModalSearchVehicles, setShowModalSearchVehicles] = useState(false); 
    const dispatch = useDispatch(); 
    const [postalCodeOriToSelect,setPostalCodeOriToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeOri, setFilteredpostalCodeOri] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeOri, setHighlightedIndexPostalCodeOri] = useState(-1); // Índice de la opción resaltada 
    const [documentIdOriToSelect,setDocumentIdOriToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdOri, setFilteredDocumentIdOri] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdOri, setHighlightedIndexDocumentIdOri] = useState(-1); // Índice de la opción resaltada 
    const [tradenameOriToSelect,setTradenameOriToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedOri, setFilteredTradenamedOri] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedOri, setHighlightedIndexTradenamedOri] = useState(-1); // Índice de la opción resaltada 
    const [oriTrasNimaToSelect,setOriTrasNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredOriTrasNima, setFilteredOriTrasNima] = useState([]); // Opciones filtradas
    const [highlightedIndexOriTrasNima, setHighlightedIndexOriTrasNima] = useState(-1); // Índice de la opción resaltada 
       
    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
    };

    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeOri([]);
            setHighlightedIndexPostalCodeOri(-1);
        return;
        }
        const filtered = postalCodeOriToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeOri(filtered);
        setHighlightedIndexPostalCodeOri(0);
    }, 300); 
    const handleSelectPostalCodeOri = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
            ...formForm,
            ori_tras_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            ori_tras_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            ori_tras_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            ori_tras_province_id: postal.province_id || Number(DEFAULTPROVINCE),
            ori_tras_province_name: postal.province_name || DEFAULTPROVINCE_NAME
        }));
        setFilteredpostalCodeOri([]);
        setHighlightedIndexPostalCodeOri(-1);
    }; 
    const handleKeyDownDPostalCodeOri = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeOri.length === 0 && formForm.ori_tras_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeOri(postalCodeOriToSelect);
            setHighlightedIndexPostalCodeOri(0);
        } else {
            setHighlightedIndexPostalCodeOri((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeOri.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexPostalCodeOri((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeOri >= 0) {
            if (highlightedIndexPostalCodeOri >= 0 && highlightedIndexPostalCodeOri < filteredpostalCodeOri.length) {
                handleSelectPostalCodeOri(filteredpostalCodeOri[highlightedIndexPostalCodeOri]);
            }
        } else if (event.key === "Escape") {
        const isValid = postalCodeOriToSelect.some((postal) => {
            if (!postal || !postal.postalcode) return false; 
            const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
            const normalizedInputId = formForm.ori_tras_postalcode_code.toUpperCase();
            return normalizedPostalCodeId === normalizedInputId;
        }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm,
                ori_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                ori_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                ori_tras_province_id: Number(DEFAULTPROVINCE),
                ori_tras_province_name: DEFAULTPROVINCE_NAME
            }));
        } 
        setFilteredpostalCodeOri([]);
        setHighlightedIndexPostalCodeOri(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchDocumentIdOri = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdOri([]);
            setHighlightedIndexDocumentIdOri(-1);
            return;
        }
        const filtered = documentIdOriToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentId = store.documentid.toUpperCase();
            return documentId.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdOri(filtered);
        setHighlightedIndexDocumentIdOri(0);
    }, 300);  
    const handleSelectDocumentIdOri = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        ori_tras_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdOri([]);
        setHighlightedIndexDocumentIdOri(-1);
    }; 
    const handleKeyDownDocumentIdOri = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdOri.length === 0 && formForm.ori_tras_documentid.trim() === "") {
            setFilteredDocumentIdOri(documentIdOriToSelect);
            setHighlightedIndexDocumentIdOri(0);
        } else {
            setHighlightedIndexDocumentIdOri((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdOri.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexDocumentIdOri((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdOri >= 0) {
        if (highlightedIndexDocumentIdOri >= 0 && highlightedIndexDocumentIdOri < filteredDocumentIdOri.length) {
            handleSelectDocumentIdOri(filteredDocumentIdOri[highlightedIndexDocumentIdOri]);
        }
        } else if (event.key === "Escape") {
        const isValid = documentIdOriToSelect.some((store) => {
            if (!store || !store.documentid) return false; 
            const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
            const normalizedInputId = formForm.ori_tras_documentid.toUpperCase();
            return normalizedStoreId === normalizedInputId;
        }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            ori_tras_documentid: "",
            }));
        } 
        setFilteredDocumentIdOri([]);
        setHighlightedIndexDocumentIdOri(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchTradenameOri= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedOri([]);
            setHighlightedIndexTradenamedOri(-1);
        return;
        }
        const filtered = tradenameOriToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedOri(filtered);
        setHighlightedIndexTradenamedOri(0);
    }, 300);  
    const handleSelectTradeNameOri = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        ori_tras_tradename: store.tradename || "",
        ori_tras_documentid: store.documentid || formForm.ori_tras_documentid,
        
        }));
        setFilteredTradenamedOri([]);
        setHighlightedIndexTradenamedOri(-1);
    }; 
    const handleKeyDownTradenameOri = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedOri.length === 0 && formForm.ori_tras_tradename.trim() === "") {
            setFilteredTradenamedOri(tradenameOriToSelect);
            setHighlightedIndexTradenamedOri(0);
        } else {
            setHighlightedIndexTradenamedOri((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedOri.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedOri((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedOri >= 0) {
        if (highlightedIndexTradenamedOri >= 0 && highlightedIndexTradenamedOri < filteredTradenamedOri.length) {
            handleSelectTradeNameOri(filteredTradenamedOri[highlightedIndexTradenamedOri]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameOriToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formForm.ori_tras_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            ori_tras_tradename: "",
            }));
        } 
        setFilteredTradenamedOri([]);
        setHighlightedIndexTradenamedOri(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchOriTrasNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredOriTrasNima([]);
            setHighlightedIndexOriTrasNima(-1);
        return;
        }
        const filtered = oriTrasNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredOriTrasNima(filtered);
        setHighlightedIndexOriTrasNima(0);
    }, 300); 
    const handleSelectOriTrasNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        ori_tras_nima: nt.nima || ""
        }));
        setFilteredOriTrasNima([]);
        setHighlightedIndexOriTrasNima(-1);
    }; 
    const handleKeyDownOriTrasNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredOriTrasNima.length === 0 && formForm.ori_tras_nima.trim() === "") {
                const filtered = oriTrasNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredOriTrasNima(filtered);
                setHighlightedIndexOriTrasNima(0);
            } else {
                setHighlightedIndexOriTrasNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredOriTrasNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexOriTrasNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexOriTrasNima >= 0) {
            if (highlightedIndexOriTrasNima >= 0 && highlightedIndexOriTrasNima < filteredOriTrasNima.length) {
                handleSelectOriTrasNima(filteredOriTrasNima[highlightedIndexOriTrasNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = oriTrasNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formForm.ori_tras_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm, 
                ori_tras_nima: ""
            }));
        } 
        setFilteredOriTrasNima([]);
        setHighlightedIndexOriTrasNima(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index) => {
        const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
        const item = dropdown?.children[index];
        if (item) {
        item.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
        }
    };

    const handleBlur = useCallback((event) => {
        if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeOri([]);
            setHighlightedIndexPostalCodeOri(-1);
            setFilteredDocumentIdOri([]);
            setHighlightedIndexDocumentIdOri(-1);
            setFilteredTradenamedOri([]);
            setHighlightedIndexTradenamedOri(-1); 
            setFilteredOriTrasNima([]);
            setHighlightedIndexOriTrasNima(-1);  
        }
    }, []);

    const handleChangeSelectDocumentType_Ori_Tras = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            ori_tras_documnettype_id:event.target.value
        }));
    };
    const handleBlurSelectDocumentType_Ori_Tras = (e) => {
        handleChangeSelectDocumentType_Ori_Tras(e);
    };
    
    const handleChangeSelectRoadType_Ori_Tras = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            ori_tras_roadtype_id : event.target.value 
        }));
    };
    const handleBlurSelectRoadType_Ori_Tras = (e) => {
        handleChangeSelectRoadType_Ori_Tras(e);
        setErrorsForm(validateFormForm());
    };
    
    const handleChangeSelectCommunity_Ori_Tras = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            ori_tras_community_id : event.target.value   
        }));
    };
    const handleBlurSelectCommunity_Ori_Tras = (e) => {
        handleChangeSelectCommunity_Ori_Tras(e);
        setErrorsForm(validateFormForm());
    };

    const handleChangeDataEditForm_Ori_Tras = (e) => {
        const { name, value } = e.target;
        setFormForm(formForm => ({
          ...formForm,
          [name]: value,
        }));
    };
    const handleBlurDataEditForm_Ori_Tras = (e) => {
        handleChangeDataEditForm_Ori_Tras(e);
        setErrorsForm(validateFormForm());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormStoreAddress = (event) => {
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => {
        setShowModalSearchStoresNimaAddress(true);
    };

    const searchFormVehicles = (event) => {
        setShowModalSearchVehicles(true);
    };

    const deleteDateOriTras = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            ori_tras_store_id:0,
            ori_tras_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
            ori_tras_documentid:"",
            ori_tras_tradename: "",
            ori_tras_name: "",
            ori_tras_contactname: "",
            ori_tras_roadtype_id: Number(DEFAULTROADTYE),
            ori_tras_street: "",
            ori_tras_country_id: Number(DEFAULTCOUNTRY),
            ori_tras_country_name:DEFAULTCOUNTRY_NAME,
            ori_tras_province_id: Number(DEFAULTPROVINCE),
            ori_tras_province_name:DEFAULTPROVINCE_NAME,
            ori_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            ori_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            ori_tras_community_id: Number(DEFAULTCOMMUNITY),
            ori_tras_community_name: DEFAULTCOMMUNITY_NAME,
            ori_tras_phone: "",
            ori_tras_email: "",
            ori_tras_nima: "",
            ori_tras_cnae: "",
            ori_tras_inscription: "",
            ori_tras_opt: 0,
            ori_tras_licenseplate: "",
            ori_tras_economicactivity:""
        }));
        setErrorsForm(validateFormForm());
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            ori_tras_store_id:"",
            ori_tras_documnettype_id: "",
            ori_tras_documentid:"",
            ori_tras_tradename: "",
            ori_tras_name: "",
            ori_tras_contactname: "",
            ori_tras_roadtype_id: "",
            ori_tras_street: "",
            ori_tras_country_id: "",
            ori_tras_province_id: "",
            ori_tras_postalcode_id: "",
            ori_tras_postalcode_code:"",
            ori_tras_community_id: "",
            ori_tras_phone: "",
            ori_tras_email: "",
            ori_tras_nima: "",
            ori_tras_cnae: "",
            ori_tras_inscription: "",
            ori_tras_opt: "",
            ori_tras_licenseplate: "",
            ori_tras_economicactivity:""
        }));
    };

    const deleteDataSteetOriTras = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            ori_tras_roadtype_id: Number(DEFAULTROADTYE),
            ori_tras_street: "",
            ori_tras_country_id: Number(DEFAULTCOUNTRY),
            ori_tras_country_name:DEFAULTCOUNTRY_NAME,
            ori_tras_province_id: Number(DEFAULTPROVINCE),
            ori_tras_province_name:DEFAULTPROVINCE_NAME,
            ori_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
            ori_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            ori_tras_community_id: Number(DEFAULTCOMMUNITY),
            ori_tras_community_name: DEFAULTCOMMUNITY_NAME,
            ori_tras_nima: "", 
            ori_tras_inscription: "",
            ori_tras_opt: 0
        }));
        setErrorsForm(validateFormForm());
    };

    const deleteDataVehicleOriTras = (event) => {
        setFormForm(formForm => ({
          ...formForm,
          ori_tras_licenseplate: ""
        }));
        setErrorsForm(validateFormForm());
    };

    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`form/getexiststorebynumberdocument/`,token,formForm.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim());
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formForm.ori_tras_store_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`form/getformstorebynumberdocument`,token,formForm.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim(),2);
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormForm(formForm => ({
                            ...formForm,
                            ori_tras_store_id: getData.store_id,
                            ori_tras_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                            ori_tras_tradename: getData.tradename,
                            ori_tras_name: getData.name,
                            ori_tras_contactname: getData.contacperson,
                            ori_tras_roadtype_id: (getData.roadtype_id===undefined 
                                                    || getData.roadtype_id===null  
                                                    || getData.roadtype_id===""
                                                    || getData.roadtype_id==="0"
                                                    || getData.roadtype_id===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id,
                            ori_tras_street: getData.street,
                            ori_tras_country_id: (getData.country_id===undefined 
                                                    || getData.country_id===null  
                                                    || getData.country_id===""
                                                    || getData.country_id==="0"
                                                    || getData.country_id===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id,
                            ori_tras_country_name: (getData.country_name===undefined 
                                                    || getData.country_name===null  
                                                    || getData.country_name==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name,
                            ori_tras_province_id: (getData.province_id===undefined 
                                                    || getData.province_id===null  
                                                    || getData.province_id===""
                                                    || getData.province_id==="0"
                                                    || getData.province_id===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id,
                            ori_tras_province_name: (getData.province_name===undefined 
                                                    || getData.province_name===null  
                                                    || getData.province_name==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name, 
                            ori_tras_postalcode_id: (getData.postalcode_id===undefined 
                                                        || getData.postalcode_id===null  
                                                        || getData.postalcode_id===""
                                                        || getData.postalcode_id==="0"
                                                        || getData.postalcode_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                            ori_tras_postalcode_code: (getData.postalcode_code===undefined 
                                                        || getData.postalcode_code===null  
                                                        || getData.postalcode_code==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                            ori_tras_postalcode_name:   (getData.postalcode_name===undefined 
                                                        || getData.postalcode_name===null  
                                                        || getData.postalcode_name==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                            ori_tras_community_id: (getData.community_id===undefined 
                                                        || getData.community_id===null  
                                                        || getData.community_id===""
                                                        || getData.community_id==="0"
                                                        || getData.community_id===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id,
                            ori_tras_community_name:   (getData.community_name===undefined 
                                                        || getData.community_name===null  
                                                        || getData.community_name==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name,  
                            ori_tras_phone: getData.phone,
                            ori_tras_email: getData.email,
                            ori_tras_nima: getData.nima_ori_tras,
                            ori_tras_cnae: getData.cnae,
                            ori_tras_inscription: getData.pygr_ori_tras,
                            ori_tras_opt: getData.opt_ori_tras,
                            ori_tras_licenseplate: getData.licenseplate,
                            ori_tras_economicactivity:getData.economicactivity
                        }));
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formForm.ori_tras_documentid && formForm.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formForm.ori_tras_documentid,errorsForm.ori_tras_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,DEFAULTPROVINCE,DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT,setFormForm,formForm.ori_tras_store_id]);
       
    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdOri = async () => {
            try {
            const getData = await helpHttp().get2(ENDPOINT,`form/getlistdocumentidformdi/`,token,
                (formForm.ori_tras_documentid!==undefined && formForm.ori_tras_documentid!==null && formForm.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                setDocumentIdOriToSelect(getData); 
            }
            } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formForm.ori_tras_documentid && formForm.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdOri();
            }
        } else{
            setDocumentIdOriToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.ori_tras_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameOri = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`form/getlisttradenameformdi/`,token,
                    (formForm.ori_tras_tradename!==undefined && formForm.ori_tras_tradename!==null && formForm.ori_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.ori_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameOriToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formForm.ori_tras_tradename && formForm.ori_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameOri();
            }
        } else{
            setTradenameOriToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.ori_tras_tradename,expanded]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeOri = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`form/getlistpostalcodeformdi/`,token,
                    (formForm.ori_tras_postalcode_code!==undefined && formForm.ori_tras_postalcode_code!==null && formForm.ori_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.ori_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeOriToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
         if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formForm.ori_tras_postalcode_code && formForm.ori_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeOri();
            } 
        } else{
            setPostalCodeOriToSelect(initialPostalCodesToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.ori_tras_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormForm]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaOriTras = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchdcs/getlistnimas`,token,formForm.ori_tras_store_id, 
                    (formForm.ori_tras_nima!==undefined && formForm.ori_tras_nima!==null && formForm.ori_tras_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.ori_tras_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setOriTrasNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formForm.ori_tras_store_id && formForm.ori_tras_store_id!==null && formForm.ori_tras_store_id!=="" && formForm.ori_tras_store_id!=="0" && formForm.ori_tras_store_id!==0){
                fetchDataNimaOriTras(); 
            }else{
                setOriTrasNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm,expanded,setFormForm,formForm.ori_tras_store_id]);
    
    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_DocuentType')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField autoComplete="off"
                    id="ori_tras_documnettype_id"
                    name="ori_tras_documnettype_id"
                    value={ (formForm.ori_tras_documnettype_id === undefined || formForm.ori_tras_documnettype_id ===null || formForm.ori_tras_documnettype_id ===""
                        || formForm.ori_tras_documnettype_id ==="0" || formForm.ori_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formForm.ori_tras_documnettype_id}
                    inputProps={{ style: {width: 100,  fontSize: '18px'}, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    variant="outlined"
                    onBlur={handleBlurSelectDocumentType_Ori_Tras}
                    onChange={handleChangeSelectDocumentType_Ori_Tras}
                    disabled={!ori_tras_handle_documnettype || hasbeenshared}
                    helperText={errorsForm.ori_tras_documnettype_id!=null && errorsForm.ori_tras_documnettype_id!==""?t(errorsForm.ori_tras_documnettype_id):""}
                    select
                    SelectProps={{
                        native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                        value: (formForm.ori_tras_documnettype_id === undefined || formForm.ori_tras_documnettype_id ===null || formForm.ori_tras_documnettype_id ===""
                            || formForm.ori_tras_documnettype_id ==="0" || formForm.ori_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formForm.ori_tras_documnettype_id
                    }}>
                    <MenuItem key={0} value=""/>
                    {documentTypesToSelect.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>  
                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CIF')} :</label>
            
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ position: "relative" }}>
                    <TextField autoComplete="off"
                        id="ori_tras_documentid"
                        name="ori_tras_documentid"
                        value={formForm.ori_tras_documentid}
                        onChange={(e) => {
                            setFormForm(prev => ({
                            ...prev,
                            ori_tras_documentid: e.target.value.toUpperCase()
                            }));
                            debouncedHandleSearchDocumentIdOri(e.target.value);
                        }}
                        onKeyDown={handleKeyDownDocumentIdOri}
                        onBlur={(event) => {
                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                            handleBlur();
                            }
                        }}
                        label={errorsForm.ori_tras_documentid!=null && errorsForm.ori_tras_documentid!==""?t(errorsForm.ori_tras_documentid):t('PlaceHolder_FORM_CIF')}
                        placeholder={t('PlaceHolder_FORM_CIF')}
                        variant="standard"
                        inputProps={{ style: {width: i18n.language==='es'?245:285,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        disabled={!ori_tras_handle_documentid || hasbeenshared}
                    />  
                    {/* Desplegable dinámico */}
                    {filteredDocumentIdOri.length > 0 && (
                        <div
                            className="dropdown-class"
                            style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "750px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                            }}
                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                        >
                            {filteredDocumentIdOri.map((store, index) => (
                            <MenuItem
                                key={store.id}
                                onClick={() => handleSelectDocumentIdOri(store)}
                                style={{
                                    cursor: "pointer",
                                    padding: "8px",
                                    borderBottom: "1px solid #eee",
                                    fontSize: '18px',
                                    backgroundColor:
                                    index === highlightedIndexDocumentIdOri ? "#4e73df" : "transparent",
                                    color: index === highlightedIndexDocumentIdOri ? "white" : "black",
                                }}
                            >
                                {store.documentid} - {store.tradename}
                            </MenuItem>
                            ))}
                        </div>
                    )}
                </span>   
                &nbsp;&nbsp;
                <IconButton  size="small" className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDateOriTras}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton>
                &nbsp;&nbsp;
                {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                    <IconButton  size="small" className={`edit-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={searchFormStore}>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>
                }
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField autoComplete="off"
                            id="ori_tras_tradename"
                            name="ori_tras_tradename"
                            value={formForm.ori_tras_tradename}
                            onChange={(e) => {
                                setFormForm(prev => ({
                                ...prev,
                                ori_tras_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradenameOri(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameOri}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.ori_tras_tradename!=null && errorsForm.ori_tras_tradename!==""?t(errorsForm.ori_tras_tradename):t('PlaceHolder_FORM_TRADENAME')}
                            placeholder={t('PlaceHolder_FORM_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?720:696,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            disabled={!ori_tras_handle_tradename || hasbeenshared}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredTradenamedOri.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "150%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedOri.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameOri(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedOri ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedOri ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span> 
                </div>
            </div>
            {ori_tras_view_name &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField autoComplete="off"
                        id="ori_tras_name" 
                        name="ori_tras_name"
                        value={formForm.ori_tras_name}
                        inputProps={{ style: {width: i18n.language==='es'?674:719,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_name!=null && errorsForm.ori_tras_name!==""?t(errorsForm.ori_tras_name):t('PlaceHolder_FORM_NAME')}
                        placeholder={t('PlaceHolder_FORM_NAME')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Ori_Tras}
                        onChange={handleChangeDataEditForm_Ori_Tras}
                        disabled={!ori_tras_handle_name || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            {ori_tras_view_contactname &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CONTACT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField autoComplete="off"
                        id="ori_tras_contactname" 
                        name="ori_tras_contactname"
                        value={formForm.ori_tras_contactname}
                        inputProps={{ style: {width: i18n.language==='es'?657:702,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_contactname!=null && errorsForm.ori_tras_contactname!==""?t(errorsForm.ori_tras_contactname):t('PlaceHolder_FORM_CONTACT')}
                        placeholder={t('PlaceHolder_FORM_CONTACT')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Ori_Tras}
                        onChange={handleChangeDataEditForm_Ori_Tras}
                        disabled={!ori_tras_handle_contactname || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            {ori_tras_view_address &&
                <>
                    <div className="row p-2"> 
                        <div className="form-group">
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_RoadType')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField autoComplete="off"
                            id="ori_tras_roadtype"
                            name="ori_tras_roadtype"
                            value={ (formForm.ori_tras_roadtype_id === undefined || formForm.ori_tras_roadtype_id ===null || formForm.ori_tras_roadtype_id ===""
                                || formForm.ori_tras_roadtype_id ==="0" || formForm.ori_tras_roadtype_id ===0)?"":formForm.ori_tras_roadtype_id}
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            variant="outlined"
                            onBlur={handleBlurSelectRoadType_Ori_Tras}
                            onChange={handleChangeSelectRoadType_Ori_Tras}
                            disabled={!ori_tras_handle_address || hasbeenshared}
                            helperText={errorsForm.ori_tras_roadtype_id!=null && errorsForm.ori_tras_roadtype_id!==""?t(errorsForm.ori_tras_roadtype_id):""}
                            select
                            SelectProps={{
                                native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                                value: (formForm.ori_tras_roadtype_id === undefined || formForm.ori_tras_roadtype_id ===null || formForm.ori_tras_roadtype_id ===""
                                    || formForm.ori_tras_roadtype_id ==="0" || formForm.ori_tras_roadtype_id ===0)?"": formForm.ori_tras_roadtype_id
                            }}>
                            <MenuItem key={0} value=""/>
                            {roadTypesToSelect.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </MenuItem>
                            ))}
                        </TextField>  
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Address')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField autoComplete="off"
                            id="ori_tras_street" 
                            name="ori_tras_street"
                            value={formForm.ori_tras_street}
                            inputProps={{ style: {width: i18n.language==='es'?361:374,  fontSize: '18px', }, maxLength: 250 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.ori_tras_street!=null && errorsForm.ori_tras_street!==""?t(errorsForm.ori_tras_street):t('PlaceHolder_FORM_Address')}
                            placeholder={t('PlaceHolder_FORM_Address')}
                            variant="standard"
                            onBlur={handleBlurDataEditForm_Ori_Tras}
                            onChange={handleChangeDataEditForm_Ori_Tras}
                            disabled={!ori_tras_handle_address || hasbeenshared}
                        />
                        </div>
                        &nbsp;&nbsp;
                        <IconButton  size="small" className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDataSteetOriTras}>
                            <DeleteIcon style={{fontSize: 28}}/>
                        </IconButton>
                        &nbsp;&nbsp;
                        {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formForm.ori_tras_documentid!==undefined && formForm.ori_tras_documentid!=="") ?
                            <IconButton  size="small" className={`edit-${
                                (formForm.ori_tras_store_id===undefined
                                || formForm.ori_tras_store_id===""
                                || formForm.ori_tras_store_id==="0"
                                || formForm.ori_tras_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                disabled={(formForm.ori_tras_store_id===undefined
                                || formForm.ori_tras_store_id===""
                                || formForm.ori_tras_store_id==="0"
                                || formForm.ori_tras_store_id===0 || hasbeenshared)}  onClick={searchFormStoreAddress}>
                                <SearchIcon style={{fontSize: 28}}/>
                            </IconButton>:
                            <IconButton  size="small" className="edit-noselect-button" disabled>
                                <SearchIcon style={{fontSize: 28}}/>
                            </IconButton>
                        }
                    </div>
                    <div className="row p-2"> 
                        <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_PostalCode')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <span style={{ position: "relative" }}>
                                <TextField autoComplete="off"
                                    id="ori_tras_postalcode_code"
                                    name="ori_tras_postalcode_code"
                                    value={formForm.ori_tras_postalcode_code}
                                    onChange={(e) => {
                                          setFormForm(prev => ({
                                            ...prev,
                                            ori_tras_postalcode_code: e.target.value.toUpperCase()
                                        }));
                                        debouncedHandleSearchPostalCode(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownDPostalCodeOri}
                                    onBlur={(event) => {
                                        if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            const inputPostalCode = formForm.ori_tras_postalcode_code.trim().toUpperCase();
                                            const matchedPostal = postalCodeOriToSelect.find((postal) => {
                                            const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                            return normalizedPostal === inputPostalCode;
                                            });

                                            if (matchedPostal) {
                                                setFormForm((prev) => ({
                                                    ...prev,
                                                    ori_tras_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                                    ori_tras_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                                    ori_tras_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                                    ori_tras_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE), 
                                                    ori_tras_province_name: matchedPostal.province_name || DEFAULTPROVINCE_NAME
                                                }));
                                            } else {
                                                setFormForm((prev) => ({
                                                    ...prev,
                                                    ori_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                                    ori_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                                    ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                                    ori_tras_province_id: Number(DEFAULTPROVINCE),
                                                    ori_tras_province_name: DEFAULTPROVINCE_NAME
                                                }));
                                            }
                                            setFilteredpostalCodeOri([]);
                                            setHighlightedIndexPostalCodeOri(-1);
                                        }
                                    }}
                                    label={errorsForm.ori_tras_postalcode_code!=null && errorsForm.ori_tras_postalcode_code!==""?t(errorsForm.ori_tras_postalcode_code):t('Text_FORM_PostalCode')}
                                    placeholder={t('Text_FORM_PostalCode')}
                                    variant="standard"
                                    inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                />  
                                {/* Desplegable dinámico */}
                                {filteredpostalCodeOri.length > 0 && (
                                    <div
                                        className="dropdown-class"
                                        style={{
                                            position: "absolute",
                                            left:'0px',
                                            border: "2px solid #4e73df", // Borde azul (#4e73df)
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "700%", 
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa", // Fondo gris claro
                                            zIndex: 1000,
                                        }}
                                        onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                        {filteredpostalCodeOri.map((postal, index) => (
                                        <MenuItem
                                            key={postal.id}
                                            onClick={() => handleSelectPostalCodeOri(postal)}
                                            style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor:
                                                index === highlightedIndexPostalCodeOri ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexPostalCodeOri ? "white" : "black",
                                            }}
                                        >
                                            {postal.postalcode} - {postal.name} - {postal.province_name}
                                        </MenuItem>
                                        ))}
                                    </div>
                                )}
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Locality')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="ori_tras_postalcode_name" 
                                name="ori_tras_postalcode_name"
                                value={formForm.ori_tras_postalcode_name}
                                inputProps={{ style: {width: i18n.language==='es'?473:503,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.ori_tras_postalcode_name!=null && errorsForm.ori_tras_postalcode_name!==""?t(errorsForm.ori_tras_contactname):t('Text_FORM_Locality')}
                                placeholder={t('Text_FORM_Locality')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Ori_Tras}
                                onChange={handleChangeDataEditForm_Ori_Tras}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="row p-2"> 
                        <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Community')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="ori_tras_community_id"
                                name="ori_tras_community_id"
                                value={ (formForm.ori_tras_community_id === undefined || formForm.ori_tras_community_id ===null || formForm.ori_tras_community_id ===""
                                    || formForm.ori_tras_community_id ==="0" || formForm.ori_tras_community_id ===0)?Number(DEFAULTCOMMUNITY):formForm.ori_tras_community_id}
                                inputProps={{ style: {width: i18n.language==='es'?250:250,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurSelectCommunity_Ori_Tras}
                                onChange={handleChangeSelectCommunity_Ori_Tras}
                                disabled={!ori_tras_handle_address || hasbeenshared}
                                helperText={errorsForm.ori_tras_community_id!=null  && errorsForm.ori_tras_community_id!==""?t(errorsForm.ori_tras_community_id):""}
                                select
                                SelectProps={{
                                    native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                                    value: (formForm.ori_tras_community_id === undefined || formForm.ori_tras_community_id ===null || formForm.ori_tras_community_id ===""
                                        || formForm.ori_tras_community_id ==="0" || formForm.ori_tras_community_id ===0)?Number(DEFAULTCOMMUNITY): formForm.ori_tras_community_id
                                }}>
                                {communityToSelect.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {i18n.language==="es"?option.namees:option.nameen}
                                    </MenuItem>
                                ))}
                            </TextField>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Province')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="ori_tras_province_name" 
                                name="ori_tras_province_name"
                                value={formForm.ori_tras_province_name}
                                inputProps={{ style: {width: i18n.language==='es'?300:305,  fontSize: '18px', }, maxLength: 30 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.ori_tras_province_name!=null && errorsForm.ori_tras_province_name!==""?t(errorsForm.ori_tras_province_name):t('Text_FORM_Province')}
                                placeholder={t('Text_FORM_Province')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Ori_Tras}
                                onChange={handleChangeDataEditForm_Ori_Tras}
                                disabled
                            />
                        </div>
                    </div>
                     
                     
                </>
            }    
            { (ori_tras_view_phone || ori_tras_view_email || ori_tras_view_nima) &&
                <div className="row p-2"> 
                    <div className="form-group">
                        {ori_tras_view_phone &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Phone')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField autoComplete="off"
                                    id="ori_tras_phone" 
                                    name="ori_tras_phone"
                                    value={formForm.ori_tras_phone}
                                    inputProps={{ style: {width: i18n.language==='es'?180:180,  fontSize: '18px', }, maxLength: 30 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={errorsForm.ori_tras_phone!=null && errorsForm.ori_tras_phone!==""?t(errorsForm.ori_tras_phone):t('PlaceHolder_FORM_Phone')}
                                    placeholder={t('PlaceHolder_FORM_Phone')}
                                    variant="standard"
                                    onBlur={handleBlurDataEditForm_Ori_Tras}
                                    onChange={handleChangeDataEditForm_Ori_Tras}
                                    disabled={!ori_tras_handle_phone || hasbeenshared}
                                />
                                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                            </>
                        }
                        {ori_tras_view_email &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Email')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField autoComplete="off"
                                    id="ori_tras_email" 
                                    name="ori_tras_email"
                                    value={formForm.ori_tras_email}
                                    inputProps={{ style: {width:  (!ori_tras_view_phone || !ori_tras_view_nima)?(i18n.language==='es'?380:394):(i18n.language==='es'?181:197) ,  fontSize: '18px'}, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={errorsForm.ori_tras_email!=null && errorsForm.ori_tras_email!==""?t(errorsForm.ori_tras_email):t('PlaceHolder_FORM_Email')}
                                    placeholder={t('PlaceHolder_FORM_Email')}
                                    variant="standard"
                                    onBlur={handleBlurDataEditForm_Ori_Tras}
                                    onChange={handleChangeDataEditForm_Ori_Tras}
                                    disabled={!ori_tras_handle_email || hasbeenshared}
                                />
                                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                            </>
                        }
                        {ori_tras_view_nima &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NIMA')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <span style={{ position: "relative" }}>
                                    <TextField autoComplete="off"
                                        id="ori_tras_nima"
                                        name="ori_tras_nima"
                                        value={formForm.ori_tras_nima}
                                        onChange={(e) => {
                                            setFormForm(prev => ({
                                            ...prev,
                                            ori_tras_nima: e.target.value.toUpperCase()
                                            }));
                                            debouncedHandleSearchOriTrasNima(e.target.value);
                                        }}
                                        onKeyDown={handleKeyDownOriTrasNima}
                                        onBlur={(event) => {
                                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            handleBlur();
                                            }
                                        }}
                                        label={errorsForm.ori_tras_nima!=null && errorsForm.ori_tras_nima!==""?t(errorsForm.ori_tras_nima):t('PlaceHolder_FORM_NIMA')}
                                        placeholder={t('PlaceHolder_FORM_NIMA')}
                                        variant="standard"
                                        inputProps={{ style: {width: (!ori_tras_view_phone || !ori_tras_view_email)?133:133,  fontSize: '18px'}, maxLength: 50 }}
                                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                        disabled={!ori_tras_handle_nima || hasbeenshared}
                                    />  
                                    {/* Desplegable dinámico */}
                                    {filteredOriTrasNima.length > 0 && (
                                        <div
                                            className="dropdown-class"
                                            style={{
                                                position: "absolute",
                                                left:'0px',
                                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                                borderRadius: "4px",
                                                marginTop: "4px",
                                                maxHeight: "200px",
                                                maxWidth: "750px",
                                                overflowY: "auto",
                                                width: "100%",
                                                fontSize: '18px',
                                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                                zIndex: 1000,
                                            }}
                                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                        >
                                            {filteredOriTrasNima.map((nt, index) => (
                                            <MenuItem
                                                key={nt.id}
                                                onClick={() => handleSelectOriTrasNima(nt)}
                                                style={{
                                                    cursor: "pointer",
                                                    padding: "8px",
                                                    borderBottom: "1px solid #eee",
                                                    fontSize: '18px',
                                                    backgroundColor:
                                                    index === highlightedIndexOriTrasNima ? "#4e73df" : "transparent",
                                                    color: index === highlightedIndexOriTrasNima ? "white" : "black",
                                                }}
                                            >
                                                {nt.nima}
                                            </MenuItem>
                                            ))}
                                        </div>
                                    )}
                                </span>
                                 &nbsp;&nbsp;
                                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formForm.ori_tras_documentid!==undefined && formForm.ori_tras_documentid!=="") ?
                                    <IconButton  size="small" className={`edit-${
                                        (formForm.ori_tras_store_id===undefined
                                        || formForm.ori_tras_store_id===""
                                        || formForm.ori_tras_store_id==="0"
                                        || formForm.ori_tras_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                        disabled={(formForm.ori_tras_store_id===undefined
                                        || formForm.ori_tras_store_id===""
                                        || formForm.ori_tras_store_id==="0"
                                        || formForm.ori_tras_store_id===0 || hasbeenshared)}  onClick={searchFormStoreNimaAddress}>
                                        <SearchIcon style={{fontSize: 28}}/>
                                    </IconButton>:
                                    <IconButton  size="small" className="edit-noselect-button" disabled>
                                        <SearchIcon style={{fontSize: 28}}/>
                                    </IconButton>
                                }
                            </>
                        }
                    </div>
                </div>  
            }
            { (ori_tras_view_inscription || ori_tras_view_opt) &&
                <div className="row p-2"> 
                    <div className="form-group">
                    {ori_tras_view_inscription &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_INSCRIPTION')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="ori_tras_inscription" 
                                name="ori_tras_inscription"
                                value={formForm.ori_tras_inscription}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !ori_tras_view_opt?350:250,  fontSize: '18px'}, maxLength: 50 }}
                                label={errorsForm.ori_tras_inscription!=null && errorsForm.ori_tras_inscription!==""?t(errorsForm.ori_tras_inscription):t('PlaceHolder_FORM_INSCRIPTION')}
                                placeholder={t('PlaceHolder_FORM_INSCRIPTION')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Ori_Tras}
                                onChange={handleChangeDataEditForm_Ori_Tras}
                                disabled={!ori_tras_handle_inscription || hasbeenshared}
                            />
                            {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        </>
                    }
                    {ori_tras_view_opt &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_OPT')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="ori_tras_opt"
                                name="ori_tras_opt"
                                value={ (formForm.ori_tras_opt === undefined || formForm.ori_tras_opt ===null || formForm.ori_tras_opt ===""
                                    || formForm.ori_tras_opt ==="0" || formForm.ori_tras_opt ===0)?0:formForm.ori_tras_opt}
                                inputProps={{ style: {width: i18n.language==='es'?170:147,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurDataEditForm_Ori_Tras}
                                onChange={handleChangeDataEditForm_Ori_Tras} 
                                helperText={errorsForm.ori_tras_opt!=null?t(errorsForm.ori_tras_opt):""}
                                disabled={!ori_tras_handle_opt || hasbeenshared}
                                select
                                SelectProps={{
                                    native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                                    value: (formForm.ori_tras_opt === undefined || formForm.ori_tras_opt ===null || formForm.ori_tras_opt ===""
                                        || formForm.ori_tras_opt ==="0" || formForm.ori_tras_opt ===0)?0: formForm.ori_tras_opt
                                }}>
                                <MenuItem key={0} value=""/>
                                {optTypeToSelect.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.code} - {option.namees.substring(0,20)}
                                </MenuItem>
                                ))}
                            </TextField> 
                        </>
                    }
                    </div>
                </div> 
            }

            { (ori_tras_view_cnae || ori_tras_view_licenseplate) &&
                <div className="row p-2"> 
                    <div className="form-group">
                    {ori_tras_view_cnae &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CNAE')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="ori_tras_cnae" 
                                name="ori_tras_cnae"
                                value={formForm.ori_tras_cnae}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !ori_tras_view_licenseplate?355:250,  fontSize: '18px'}, maxLength: 100 }}
                                label={errorsForm.ori_tras_cnae!=null && errorsForm.ori_tras_cnae!==""?t(errorsForm.ori_tras_cnae):t('PlaceHolder_FORM_CNAE')}
                                placeholder={t('PlaceHolder_FORM_CNAE')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Ori_Tras}
                                onChange={handleChangeDataEditForm_Ori_Tras}
                                disabled={!ori_tras_handle_cnae || hasbeenshared}
                            />
                            {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        </>
                    }
                    {ori_tras_view_licenseplate &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Vehicles')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="ori_tras_licenseplate" 
                                name="ori_tras_licenseplate"
                                value={formForm.ori_tras_licenseplate}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !ori_tras_view_cnae?313:(i18n.language==='es'?313:324),  fontSize: '18px'}, maxLength: 100 }}
                                label={errorsForm.ori_tras_licenseplate!=null && errorsForm.ori_tras_licenseplate!==""?t(errorsForm.ori_tras_licenseplate):t('PlaceHolder_FORM_Vehicles')}
                                placeholder={t('PlaceHolder_FORM_Vehicles')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Ori_Tras}
                                onChange={handleChangeDataEditForm_Ori_Tras}
                                disabled={!ori_tras_handle_licenseplate || hasbeenshared}
                            />
                            &nbsp;&nbsp;
                            <IconButton  size="small" className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDataVehicleOriTras}>
                                <DeleteIcon style={{fontSize: 28}}/>
                            </IconButton>
                            &nbsp;&nbsp;
                            {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                                <IconButton  size="small" className={`edit-${
                                    (formForm.ori_tras_store_id===undefined
                                    || formForm.ori_tras_store_id===""
                                    || formForm.ori_tras_store_id==="0"
                                    || formForm.ori_tras_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                    disabled={(formForm.ori_tras_store_id===undefined
                                    || formForm.ori_tras_store_id===""
                                    || formForm.ori_tras_store_id==="0"
                                    || formForm.ori_tras_store_id===0 || hasbeenshared)}  onClick={searchFormVehicles}>
                                    <SearchIcon style={{fontSize: 28}}/>
                                </IconButton>
                            } 
                        </>
                    }
                    </div>
                </div> 
            }
            {ori_tras_view_economicactivity &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Economicactivity')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField autoComplete="off"
                        id="ori_tras_economicactivity" 
                        name="ori_tras_economicactivity"
                        value={formForm.ori_tras_economicactivity}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: i18n.language==='es'?659:685,  fontSize: '18px'}, maxLength: 100 }}
                        label={errorsForm.ori_tras_economicactivity!=null && errorsForm.ori_tras_economicactivity!==""?t(errorsForm.ori_tras_economicactivity):t('PlaceHolder_FORM_Economicactivity')}
                        placeholder={t('PlaceHolder_FORM_Economicactivity')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Ori_Tras}
                        onChange={handleChangeDataEditForm_Ori_Tras}
                        disabled={!ori_tras_handle_economicactivity || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            <FormSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Ori_Tras"}
                setFormForm={setFormForm}
            />
            <FormSearchStoresAddresses
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={"Ori_Tras"}
                setFormForm={setFormForm}
                titleTable={formForm.ori_tras_tradename}
                store_id={formForm.ori_tras_store_id}
                priority={2}
            />
            <FormSearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={"Ori_Tras"}
                setFormForm={setFormForm}
                titleTable={formForm.ori_tras_tradename}
                store_id={formForm.ori_tras_store_id} 
            />
            <FormSearchStoreVehicles
                showModalSearchVehicles={showModalSearchVehicles}
                setShowModalSearchVehicles={setShowModalSearchVehicles}
                selectStores={"Ori_Tras"}
                setFormForm={setFormForm}
                titleTable={formForm.ori_tras_tradename}
                store_id={formForm.ori_tras_store_id}
            />

        </> 
    )
}

FormCreateOrEditOriTras.propTypes = {
    formForm: PropTypes.object.isRequired,
    setFormForm: PropTypes.func.isRequired,
    setIsLoadingErrorData: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateFormForm: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired,
    hasbeenshared: PropTypes.bool.isRequired
  };
  
  export default FormCreateOrEditOriTras;

